export const FETCH_PROMOTION_LIST = "FETCH_PROMOTION_LIST";
